import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../../../basic/index';
import { Spinner } from '../../../../../common/index';
import ErasmusUniversitiesForm from './ErasmusUniversitiesForm/ErasmusUniversitiesForm.jsx';
import {
  useGetErasmusUniversitiesQuery,
  useGetErasmusUniversityQuery,
  useSaveErasmusUniversityMutation,
} from '../../../../../../redux/services/erasmusUniversities';
import { routes } from '../../../../../../utils/helpers/ApiClient';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';

const ErasmusUniversitiesEdit = ({ mode, id }) => {
  const { id: urlId } = useParams();
  const displayId = id || urlId;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { saveSuccess } = useToastMessages();

  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';
  const isPreview = mode === 'preview';

  const { data: universityDetail, isLoading } = useGetErasmusUniversityQuery(
    displayId,
    {
      skip: !isEdit && !isPreview,
    },
  );

  const [saveErasmusUniversity, { isSuccess: isSaveSuccess }] =
    useSaveErasmusUniversityMutation();

  const { refetch } = useGetErasmusUniversitiesQuery();

  useEffect(() => {
    if (isSaveSuccess) {
      saveSuccess();
      navigate(routes.cmsErasmusUniversity);
      refetch();
    }
  }, [isSaveSuccess]);

   const title =
     (isCreate && t('Pridanie univerzity')) || t('Úprava univerzity');

  if (isLoading || (isEdit && !universityDetail)) {
    return <Spinner />;
  }

  const initials =
    isEdit || isPreview
      ? {
          ...universityDetail.university,
          title_photo_path: universityDetail?.university?.title_photo_path
            ? `/storage/mobility/universities/${universityDetail.university.title_photo_path}`
            : null,
        }
      : {
          name: undefined,
          country: undefined,
          city: undefined,
          OID: undefined,
          erasmus_code: undefined,
          PIC: undefined,
          contact_person: undefined,
          email: undefined,
          phone: undefined,
          description: undefined,
          website: undefined,
          latitude: undefined,
          longitude: undefined,
        };

  if (!initials) {
    return <Spinner />;
  }

  return (
    <>
      {!isPreview && (
        <AppBarCMS
          title={title}
          backUrl={routes.cmsErasmusUniversity}
          backUrlTooltip={t('Univerzity')}
          permissionsBasic={'erasmus-applications'}
        />
      )}
      <div style={{ margin: '10px' }}>
        <ErasmusUniversitiesForm
          initials={initials}
          isEdit={isEdit}
          isPreview={isPreview}
          onSubmit={(values) => {
            saveErasmusUniversity({ body: values, id: displayId });
          }}
        />
      </div>
    </>
  );
};

export default ErasmusUniversitiesEdit;
